import * as React from "react";
import { useParams } from "react-router-dom";


export function WithRouterParams(Component: any) {
    return (props: any) => <Component {...props} params={useParams()} />;
}
